import { useMemo } from "react";
import type { Certificate } from "../../../shared/models/certificate";

/**
 * Returns true if a certificate is considered "active" (active or expiring).
 * Use this as the single source of truth for counting active certificates.
 */
export function isActiveCert(c: Certificate): boolean {
  return c.status === "active" || c.status === "expiring";
}

/** Count active certificates grouped by a key extractor. */
export function useActiveCertCountMap(
  certificates: Certificate[],
  keyFn: (c: Certificate) => string,
): Map<string, number> {
  return useMemo(() => {
    const map = new Map<string, number>();
    for (const c of certificates) {
      if (!isActiveCert(c)) continue;
      const key = keyFn(c);
      map.set(key, (map.get(key) ?? 0) + 1);
    }
    return map;
  }, [certificates, keyFn]);
}
